import React, { useEffect, useRef, useState } from 'react'
import { Video } from '../common/video'
import { Spinner } from '../ui/modal';
import VideoController from './video-controller';
import { AgentV2PushContentDetailData } from '@/services/agent-v2-push-content-detail';
import { Image } from '../common/image';
import { IconButton } from '../common/icon-button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

/** 左侧Ai创作区域 */
export const LeftAiCreation: React.FC<{ details: AgentV2PushContentDetailData }> = ({ details }) => {
  const [load, setLoad] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);

  const videoUrl = details?.videoUrl || '';
  const imageUrls = details?.imageUrls || [];

  // 自动播放视频
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !open) return;
    const handleCanPlayThrough = async () => {
      try {
        await video.play();
      } catch (error) {
        console.warn("Auto-play failed:", error);
      }
    };
    video.addEventListener("canplaythrough", handleCanPlayThrough);
    // 如果视频已经可以播放，立即尝试播放
    if (video.readyState >= 3) {
      handleCanPlayThrough();
    }
    return () => {
      video.removeEventListener("canplaythrough", handleCanPlayThrough);
    };
  }, [open]);

  // 切换上一张（循环）
  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + imageUrls.length) % imageUrls.length);
  };

  // 切换下一张（循环）
  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % imageUrls.length);
  };

  return (
    <div className="group flex-1 h-full relative bg-black  flex flex-col">
      {/* 视频播放器 */}
      <div className="flex-1 flex items-center justify-center">
        <div className="absolute top-0 bottom-0 aspect-[9/16]">
          {videoUrl ? (
            <Video
              ref={videoRef}
              src={videoUrl}
              autoPlay
              preload="auto"
            />
          ) : (
            <Image
              src={details?.imageUrls?.[currentIndex] || ''}
              alt={details?.contentTitle || details?.content || ''}
              className="w-full h-full object-contain"
            />
          )}
        </div>
      </div>

      {videoUrl && (
        <>
          {load && (
            <div className="absolute inset-0 flex justify-center items-center bg-black/20">
              <Spinner className="text-white" size={32} />
            </div>
          )}

          {/* 视频控制器 */}
          <div className="opacity-0 group-hover:opacity-100 absolute bottom-0 left-0 right-0 transition-opacity duration-250">
            <VideoController videoRef={videoRef} onLoad={setLoad} />
          </div>
        </>
      )}

      {/* 左侧切换按钮 */}
      {!videoUrl && imageUrls.length > 1 && (
        <IconButton
          className="size-9 rounded-[8px] absolute left-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all bg-black/40 hover:bg-black/60 z-10"
          icon={<ChevronLeft className="w-5 h-5 text-white" />}
          onClick={handlePrev}
        />
      )}

      {/* 右侧切换按钮 */}
      {!videoUrl && imageUrls.length > 1 && (
        <IconButton
          className="size-9 rounded-[8px] absolute right-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all bg-black/40 hover:bg-black/60 z-10"
          icon={<ChevronRight className="w-5 h-5 text-white" />}
          onClick={handleNext}
        />
      )}
    </div>
  )
}
